const feedbackModals = {
  'confirmationModal.title': 'Atenção',
  'confirmationModal.description':
    'Uma vez executada, esta ação não poderá ser desfeita.',
  'confirmationModal.type': 'Digite',
  'confirmationModal.toPerform': 'para concluir',
  'confirmationModal.conclude': 'Concluir',
  'balanceModal.title': 'Ops! Só é possivel encerrar contas com saldo zero.',
  'balanceModal.description':
    'Para zerar o saldo, acesse o Backoffice, localize o cliente e realize uma das operações:',
  'balanceModal.confirm': 'entendi',
  'balanceModal.cashOutLink': 'Cash-Out TED/TEF',
  'balanceModal.sendLink': 'Emitir OP',
  'balanceModal.settingsLink': 'Realizar ajuste',
  'bankSlipsOpenedModal.title':
    'Ops! Esta conta possui boletos em aberto e não pode ser encerrada no momento.',
  'successModal.title': 'Sucesso!',
  'successModal.description': 'Operação concluída com sucesso.',
  'errorModal.title': 'Ops! Ocorreu um erro.',
  'errorModal.description': 'Operação não realizada. ',
  'errorModal.okButton': 'entendi',
};

export default feedbackModals;
